import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { TableSorter } from 'src/app/table-handling';
import { TableHeader } from 'src/app/table-handling/types';

import iconLibrary from 'src/app/common/iconLibrary';
import { ContentDirective } from '../directives';
import { GenericTableCellComponent } from '../generic-table-cell/generic-table-cell.component';
import { SortArrowsComponent } from '../sort-arrows/sort-arrows.component';
import { TableCellLinebreakComponent } from '../table-cell-linebreak/table-cell-linebreak.component';

@Component({
  selector: 'app-table-header',
  standalone: true,
  imports: [CommonModule, ContentDirective, SortArrowsComponent, TableCellLinebreakComponent],
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TableHeaderComponent extends GenericTableCellComponent implements OnChanges {
  @Input() public header: TableHeader;
  @Input() public sorter: TableSorter;
  @Input() public unsortable: boolean;

  protected readonly iconLibrary: string = iconLibrary;

  public ngOnChanges({ header }: SimpleChanges): void {
    if (!header) {
      return;
    }

    this.build();
  }

  protected override getValue(): string | number | null {
    return this.header?.label ?? null;
  }

  protected sort(): void {
    if (this.canSort()) {
      this.sorter.sort(this.header.column);
    }
  }

  protected canSort(): boolean {
    return this.header && this.sorter && !this.unsortable;
  }

  protected copyClasses() {
    const value = this.getValue();
    if(typeof value === 'string') {
      const match = value.match(/class="([^"]+)"/);
      if(match) {
        return match[1];
      }
    }
    return "";
  }
}
